import { render } from "./ContactInfo.vue?vue&type=template&id=0ef46a50"
const script = {}
script.render = render

export default script